const musicData = {
  chillMix: {
    playListTitle: "Chill Mix",
    songs: [
      {
        title: "Colorful Flowers",
        artist: "Tokyo Music Walker",
        art: "/album-art/colorful_flowers.jfif",
        audio: "/music/colorful-flowers.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Bedtime After A Coffee",
        artist: "ikkunn (Barradeen)",
        art: "/album-art/bedtime-after-coffee.jpg",
        audio: "/music/barradeen-bedtime-after-a-coffee.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Purple Dream",
        artist: "Ghostrifter Official",
        art: "/album-art/purple-dream.jpg",
        audio: "/music/Purple-Dream.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Morning Routine",
        artist: "Ghostrifter Official",
        art: "/album-art/morning-routine.jpg",
        audio: "/music/Morning-Routine.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "The Process",
        artist: "Lakey Inspired",
        art: "/album-art/The-Process.jpg",
        audio: "/music/The-Process.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Better Days",
        artist: "Lakey Inspired",
        art: "/album-art/better-days.jpg",
        audio: "/music/Better-Days.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Chill Day",
        artist: "Lakey Inspired",
        art: "/album-art/chill-day.jpg",
        audio: "/music/Chill-Day.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "Lo-fi Type Beat - Rain",
        artist: "Prod. Lee",
        art: "/album-art/lo-fi-type-beat-rain.jpg",
        audio: "/music/Lo-fi-Type-Beat-Rain.mp3",
        tag: ["chill", "cozy"],
      },
      {
        title: "I Need a Girl",
        artist: "Prod. Lee",
        art: "/album-art/i-need-a-girl.jpg",
        audio: "/music/I-Need-a-Girl.mp3",
        tag: ["chill", "cozy"],
      },
    ],
  },
  gamingMix: {
    playListTitle: "Gaming Mix",
    songs: [
      {
        title: "Kinetics",
        artist: "e s c p",
        art: "/album-art/kinetics.jpg",
        audio: "/music/kinetics.mp3",
        tag: ["gaming"],
      },
      {
        title: "Calling out your name",
        artist: "Lottie Jones, Tom Wigley, MANIA",
        art: "/album-art/calling-out-your-name.jpg",
        audio: "/music/calling-out-your-name.mp3",
        tag: ["gaming"],
      },
      {
        title: "Reason (ft. Remy Night)",
        artist: "MANIA, Remy Night",
        art: "/album-art/reason.jpg",
        audio: "/music/reason.mp3",
        tag: ["gaming"],
      },
      {
        title: "Midnight Room",
        artist: "e s c p",
        art: "/album-art/midnight-room.jpg",
        audio: "/music/midnight-room.mp3",
        tag: ["gaming"],
      },
      // Add more songs for the gaming mix if needed
    ],
  },
  jazzMix: {
    playListTitle: "Jazz Mix",
    songs: [
      {
        title: "Day Off",
        artist: "Tokyo Music Walker",
        art: "/album-art/day-off.jpg",
        audio: "/music/Day-Off.mp3",
        tag: ["Jazz"],
      },
      {
        title: "Memories of Spring",
        artist: "Tokyo Music Walker",
        art: "/album-art/memories-of-spring.jpg",
        audio: "/music/memories-of-spring.mp3",
        tag: ["Jazz"],
      },
      {
        title: "Sunset Drive",
        artist: "Tokyo Music Walker",
        art: "/album-art/sunset-drive.jfif",
        audio: "/music/sunset-drive.mp3",
        tag: ["Jazz"],
      },
      {
        title: "Lavender",
        artist: "massobeats",
        art: "/album-art/lavander.jpg",
        audio: "/music/lavander.mp3",
        tag: ["Jazz"],
      },
      {
        title: "butter",
        artist: "lukrembo",
        art: "/album-art/butter.png",
        audio: "/music/butter.mp3",
        tag: ["Jazz"],
      },
      // Add more songs for the gaming mix if needed
    ],
  },
};

export default musicData;

// Lo-fi-Type-Beat-Rain.mp3
